import { render } from "./AddDistribution.vue?vue&type=template&id=0e8fc1f8&scoped=true"
import script from "./AddDistribution.vue?vue&type=script&lang=js"
export * from "./AddDistribution.vue?vue&type=script&lang=js"

import "./AddDistribution.vue?vue&type=style&index=0&id=0e8fc1f8&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src723/src/github.com/aqfer/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e8fc1f8"]])

export default __exports__